<template>
  <div class="admin-footer no-translate" id="Footer">
    <!-- no use for now
    so commenting -->
    <!-- <a href="javascript:void(0)" class="pull-left color-blue" @click="loadMenuLink">{{ sideBarLoadLink }}</a> -->
    Copyright ©
    {{ new Date().getFullYear() }} <b class="font-bold">{{ copyRightName }}. All rights reserved.</b> Version <b
      class="font-bold">{{ version }}</b>
  </div>
</template>
<script>

import EventBus from "./event-bus";

export default {
  name: "Footer",
  data: () => ({
    copyRightName: "",
    role: "",
    sideBarLoadLink: "",
    version: localStorage.getItem("build_version"),
    userObj: "",
    loggedinUserId: "",
  }),
  watch: {
    '$route.path': function (val, oldval) {
      var self = this;
      var path = window.location.pathname;
      var pathArr = path.split("/");

      var oldPath = oldval.split("/");
      var newPath = val.split("/");

      if (newPath[2] == 'rental' || newPath[2] == 'lease') {

        var reservationRentalTabLink = /^reservation\x2Frental$/;
        var reservationLeaseTabLink = /^reservation\x2Flease$/;
        setTimeout(function () {

          $("#menu li").removeClass("active")

          if (reservationRentalTabLink.test(pathArr[1] + '/' + pathArr[2])) {
            if (oldPath[2] != 'lease') {
              $("#rentalTabLink a").click();
            }
            $("#rentalTabLink").addClass('active');
            $("#reservationRentalTabLink").addClass('active');
          } else if (reservationLeaseTabLink.test(pathArr[1] + '/' + pathArr[2])) {
            if (oldPath[2] != 'rental') {
              $("#leaseTabLink a").click();
            }
            $("#leaseTabLink").addClass('active');
            $("#reservationLeaseTabLink").addClass('active');
          }
        }, 100);
      }
    },
  },
  created: function () {
    this.copyRightName = process.env.COPYRIGHT_NAME;
  },
  mounted: function () {

    //load menu link name
    var linkName = localStorage.getItem("loadMenuLinksFor");

    if (linkName == null || linkName == "modules") {
      this.sideBarLoadLink = "Reports";
    } else {
      this.sideBarLoadLink = "Modules";
    }

    //check user loggged in or not
    this.userObj = localStorage.getItem("user_obj");

    //if user logged in than remove login button and registration button
    if (this.userObj != null) {
      var userJson = JSON.parse(this.userObj);
      if (userJson.roles.length > 0) {
        this.role = userJson.roles[0].name;

        this.loggedinUserId = userJson.id;
      }
      setTimeout(function () {
        EventBus.$emit("logged-in", true, userJson["first_name"], this.role, userJson["username"], userJson["file_path"]);
      }, 500);
    }

    // this.initMenu();
    if(this.version == null || this.version == ""){
      this.checkBuildVersion();
      // check sidebar toggle
      this.checkSidebarToggle();
    }


    var path = window.location.pathname;
    // get flag value from url
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);

    var pathArr = path.split("/");

    var customerExp = /^customer$/;
    var customercontactExp = /^customercontact$/;
    var userExpr = /^user$/;
    var vendorExp = /^vendor$/;
    var groupExp = /^group$/;
    var vehicleStatusExp = /^assetstatuses$/;
    var vehicleTypeExp = /^assettypes$/;
    var vehicleManufacturerExp = /^assetmanufacturer$/;
    var vehicleModelExp = /^assetmodel$/;
    var vehicleGroupExp = /^assetgroup$/;
    var vehicleOwnershipExp = /^assetownership$/;
    var vehiclePoolExp = /^assetpool$/;
    var locationExp = /^location$/;
    var grantPermissionTypeExp = /^grantpermission$/;
    var roleExp = /^roles$/;
    var workOrderExp = /^workorder$/;
    var permissionExp = /^permissions$/;
    var measurementExp = /^measurementunit$/;
    var vehicleExp = /^asset$/;
    var itemcategoriesExp = /^part-categories$/;
    var itemmanufacturerExp = /^part-manufacturer$/;
    var warrantyExp = /^warranty$/;
    var claimLink = /^warranty-claim$/;
    var collectionLink = /^claim-collection$/;
    var itemExp = /^part$/;
    var warehouseExp = /^warehouse$/;
    var warehouseBinMapperLink = /^warehouse-bin-mapper$/;
    var cpicodeExp = /^cpicode$/;
    var contractbillingmethodExp = /^contractbillingmethod$/;
    var contractbillingfrequencyExp = /^contractbillingfrequency$/;
    var customerclassExp = /^customerclass$/;
    var representativeExp = /^representative$/;
    var contracttypeExp = /^contracttype$/;
    var termExp = /^term$/;
    var contractExp = /^contract$/;
    var metrictypeExp = /^metrictype$/;
    var vehiclemaintanancereportingstandardsExp = /^assetmaintanance$/;
    var insurancecompanyExp = /^insurancecompany$/;
    var rentalagreementExp = /^rentalagreement$/;
    var contractunitdetailExp = /^contractassetdetail$/;
    var effectivecpirateExp = /^effectivecpirate$/;
    var cpiproofreviewExp = /^cpiproofreview$/;
    var dashboardExp = /^dashboard$/;
    var cpiacknowledgementExp = /^cpiacknowledgementmailsent$/;
    var contracttypesectionmapperExp = /^contracttypesectionmapper$/;
    var enquiryExp = /^enquiry$/;
    var invoiceExp = /^invoice$/;
    var accountReceivableInquiryExp = /^account-receivable-inquiry$/;
    var refundPaymentListExp = /^refund-payment-list$/;
    var refundEligibleListExp = /^refund-eligible-list$/;
    var paymentExp = /^payment$/;
    var reservationExp = /^reservation$/;
    var reservationleaseExp = /^lease$/;
    var unsyncDataExp = /^unsync$/;
    var transportrequestExp = /^transportrequest$/;
    var pendingreservationExp = /^pending-reservation$/;
    var creditdetails = /^customer-credit-details$/;
    var achdetails = /^customer-ach-details$/;
    var inq = /^inquiry$/;
    var needs = /^customerneeds$/;
    var scoperate = /^scoperate$/;

    var permitType = /^vehiclepermittype$/;
    var permit = /^vehiclepermit$/;
    var assetcomponent = /^assetcomponent$/;
    var featureCat = /^assetfeaturecategory$/;
    var feature = /^feature$/;
    var standardFeature = /^assetstandardfeature$/;
    var assetfeature = /^assetfeature$/;
    var odometerLink = /^telematics-reading$/;
    var importLink = /^import-data$/;
    var activity = /^activitylog$/;
    // var reservationRentalExp = /^rental$/;
    var servicesExp = /^workorder$/;
    var potentialCancellation = /^potential-cancellation$/;
    var rentalCancellation = /^rental-cancellation$/;
    // var reportExp = /^report$/;
    var vehicleLocationHistoryExp = /^assetlocation$/;
    var vehicleContractHistoryExp = /^assetcontract$/;
    var vehicleDefectsExp = /^assetdefect$/;
    var importDataReviewLink = /^importdatareview$/;
    var customerLoginLink = /^customer-login$/;
    var customerRegisterLink = /^customer-register$/;
    var customerInvoiceLineDetail = /^customer-invoice-line$/;
    var customerInteractionLink = /^customer-interaction$/;
    var utilizeAssetLink = /^utilize-asset$/;
    var billingForecastLink = /^billing-forecast$/;
    var potentialCancellationLink = /^potential-cancellation$/;
    var rentalCancellationLink = /^rental-cancellation$/;
    var reservationRentalTabLink = /^reservation\x2Frental$/;
    var reservationLeaseTabLink = /^reservation\x2Flease$/;
    var chargesLink = /^charge$/;
    var extrachargelink = /^extra-charge$/;
    var shopLink = /^shops$/;
    var insurancePolicyLink = /^insurancepolicy$/;
    var standardDefectLink = /^standard-defect$/;
    var reasonLink = /^reason$/;
    var unitReadingListExp = /^reading-notification$/;
    var crmExp = /^crm$/;
    var notesExp = /^notes$/;
    var maintenanceScheduleExp = /^maintenance-schedule$/;
    var unitReadingsExp = /^reading$/;
    var courtesyNoticeLink = /^courtesy$/;
    var noticeACHlistlink = /^ach$/;
    var pastDueNoticeLink = /^past-due$/;
    //var noticeExp = /^notice$/;
    var sentMailLink = /^sent$/;
    var mailReportLink = /^emails$/;
    var inventory = /^asset-inventory$/;
    var insuranceAgencyLink = /^insuranceagency$/;
    var checkListActionLink = /^checklist-action$/;
    var purchaseOrderLink = /^order-history$/;
    var custPurchaseOrderLink = /^customer-purchase-order$/;
    var rentalPOLink = /^purchase-order$/;
    var venPurchaseOrderLink = /^asset-purchase-order$/;
    var venItemPurchaseOrderLink = /^item-purchase-order$/;
    var assetPOLink = /\\?from=assetPO$/
    var workOrderLink = /^workorder$/;
    var estimateLink = /^estimate$/;
    var custEstimateLink = /^customer-estimate$/;
    var venEstimateLink = /^vendor-estimate$/;
    var recallAssetMapperLink = /^recall-asset-mapper$/;
    var workordertemplateLink = /^workordertemplate$/;
    var glAccountLink = /^gl-account$/;
    var billLink = /^vendor-invoice$/;
    var requisitionLink = /^asset-requisition$/;
    var purchaseorderassetdetailLink = /^vendor-purchase-order$/;
    var creditNoteLink = /^credit-note$/;
    var vehiclehvutLink = /^fhut-schedule$/;
    var vehiclelogLink = /^asset-log$/;
    var vehiclesaleLink = /^asset-sale$/;
    var journalLink = /^journal$/;
    var journalRecurringLink = /^journal-recurring$/;
    var glReportLink = /^general-ledger$/;
    var wrongGlAccountsLink = /^gl-transaction$/;
    var companyInfoLink = /^company-info$/;
    var faqLink = /^faq$/;
    var vendorPaymentLink = /^vendor-payment$/;
    var checkLink = /^check$/;
    var newsLink = /^news$/;
    var bankTransferLink = /^bank-transfer$/;
    var bankSummaryLink = /^bank-summary$/;
    var glBalanceLink = /^gl-balances$/;
    var debtNoteList = /^debtnote$/;
    var debtPaymentReconciliation = /^debtpayment$/;
    var fuelPricingLink = /^fuel-pricing$/;
    var fuelPriceLogLink = /^fuel-price$/;
    var fuelDropLink = /^fuel-drop$/;
    var fuelislandProductLink = /^fuel-island-product$/;
    var fuelTankPumpMapperLink = /^fuel-pump-map$/;
    var receiptLink = /^payment-receipt$/;
    var statementLink = /^customer-statement$/;
    var fuelTicketLink = /^fuel-ticket$/;
    var fuelReadingLink = /^fuel-reading$/;
    var accountSettingLink = /^account-setting$/;
    var scheduleReportLink = /^schedule-report$/;
    var customerReportLink = /^customer-report$/;
    var customercontactReportLink = /^customer-contact-report$/;
    var insurancePolicyReportLink = /^insurance-policy-report$/;
    var contractReportLink = /^lease-contract-report$/;
    var annualmetricvscontractmetric = /^annual-actual-contract-metric-report$/;
    var metricvscontractmetric = /^actual-contract-metric-report$/;
    var fuelTicketReportLink = /^fuel-ticket-report$/;
    var invoiceReportLink = /^invoice-disposal-report$/;
    var invoiceListReportLink = /^invoice-report$/;
    var rentalListReportLink = /^rental-report$/;
    var cpirateverificationLink = /^cpi-rate-verification-report$/;
    var scoperateReportLink = /^customer-rental-scoperate-report$/;
    var availableEquipmentReportLink = /^available-equipment-report$/;
    var reservationReportLink = /^reservation-report$/;
    var gangsheetReportLink = /^gangsheet-report$/;
    var laborManageReportLink = /^labor-management-report$/;
    var permitReportLink = /^permit-entry-report$/;
    var unitPermitReportLink = /^unit-permit-report$/;
    var hvutUnitReportLink = /^hvut-unit-report$/;
    var depreciationReportLink = /^depreciation-review-report$/;
    var debtNoteBalanceDetail = /^debt-note-balance$/;
    var inventoryReportLink = /^inventory-report$/;
    var equipmentPoolReportLink = /^equipment-pool-report$/;
    var ownedEquipmentReportLink = /^owned-equipment-report$/;
    var metricsBilledReportLink = /^metrics-billed-report$/;
    var equipmentCurrentStatusReportLink = /^equipment-current-status-report$/;
    var vehicleReportLink = /^equipment-master$/;
    var costPerMetricReport = /^cost-per-metric-unit$/;
    var generalLedgerReportLink = /^gl-detail-report$/;
    var menuoverdueLink = /^available-overdue-asset$/;
    var taxSummaryLink = /^tax-summary$/;
    var incomeSummaryLink = /^income-summary$/;
    var expenseSummaryLink = /^expense-summary$/;
    var profitLossLink = /^profit-loss$/;
    var trialBalanceLink = /^trial-balance$/;
    var subletInProcessLink = /^sublet-in-process$/;
    var fuelInventoryClearingLink = /^fuel-inventory-clearing-Summary$/;
    var accruedLiabilityLink = /^accrued-liability-report$/;
    var customerAROutstandingLink = /^customer-ar-outstanding$/;
    var depreciationLink = /^depreciation-schedule$/;
    var agreementInvExp = /^rental-agreement$/;
    var priceBookLink = /^price-book$/;
    var pricebookhistoryLink = /^price-book-history$/;
    var batchLink = /^batch$/;
    var comptransaction = /^part-transaction$/;
    var vendorPOLink = /^vendor-purchase-order$/;
    var suggestedOrderLink = /^suggested-order$/;
    var poreceipt = /^record-receipt$/;
    var compinventory = /^part-inventory$/;
    var depreciationSchLink = /^depreciation$/;
    var transportReqLink = /^transport-request$/;
    var receiptItemLink = /^receipt-item$/;
    var receiptInvoiceLink = /^receipt-invoice$/;
    var workEntryLink = /^work-entry$/;
    var laborCodeLink = /^etk$/;
    var userLogEntryLink = /^user-log-entry$/;
    var gangSheetLink = /^gang-sheet$/;
    var chargeCodeAccountLink = /^charge-code-account$/;
    var scopeheaderLink = /^scope-header/;
    var customerdiscountLink = /^customer-discount$/;
    var laborCostLink = /^labor-cost$/;
    var programLink = /^program$/;
    var oosLink = /^out-of-service$/;
    var physicalCountLink = /^physical-count$/;
    var approvedWOLink = /^approved-workorder$/;
    var shiftDetailLink = /^shift-detail$/;
    var fhutCategoryLink = /^fhut-categories$/;
    var vehicleFeatureReportLink = /^asset-feature$/;
    var citationLink = /^citation$/;
    var vmrsLink = /^vmrs-code$/;
    var rentalActivityLink = /^rental-activity-report$/;
    var actionAuditReport = /^audit-log$/;
    var rentalActivityRatesLink = /^rental-activity-rates-report$/;
    var substituteLink = /^substitute-unit-report$/;
    var currentInsuranceLink = /^current-insurance-policy-report$/;
    var agedTrialBalSummaryLink = /^customer-aged-trial-balance-summary$/;
    var PMUnitDetailLink = /^pm-unit-detail-report$/;
    var PMUnitForecastLink = /^pm-unit-forecast-report$/;
    var agedTrialBalDetailLink = /^aged-trial-balance-detail$/;
    var billingReadingForPeriod = /^billing-reading-for-period-report$/;
    var notePadReviewLink = /^note-pad-review$/;
    var netBillingMetricsForPeriod = /^net-billing-metrics-report$/;
    var weeklyRentalReportLink = /^weekly-rental-report$/;
    var agedTrialBalanceDetailGridLink = /^aged-trial-balance-detail-grid$/;
    var contractExpiryLink = /^lease-contract-expiry$/;
    var ratesandutilreport = /^lease-rates-and-utilization$/;
    var totalFleetReport = /^customer-total-fleet-report$/;
    var contractExpiryNonTemplateLink = /^lease-contract-expiry-non-template$/;
    var apTrialBalanceAsAtDetailLink = /^ap-trial-balance-as-at-detail$/;
    var apVoucherDistributionLink = /^ap-voucher-distribution-edit$/;
    var apPositivePayLink = /^ap-positive-pay-listing$/;
    var arReceiptAndApplicationLink = /^ar-receipt-and-application$/;
    var woAccountingTransactionLink = /^work-order-accounting-transaction$/;
    var openOnAccountCashLink = /^open-on-account-cash$/;
    var unitProfitLossSummaryLink = /^ltd-unit-profit-loss-summary$/;
    var PMComplianceFacilityLink = /^pm-compliance-facility$/;
    var PMCompliancePoolLink = /^pm-compliance-pool$/;
    var contractCustomerReportLink = /^contract-customer-report$/;
    var contractEquipmentReportLink = /^contract-equipment-as-at-report$/;
    var contractEquipUtilizationReportLink = /^contract-equipment-utilzation-report$/;
    var unitsWithoutActiveContractsLink = /^units-without-active-contracts$/;
    var depreciationNBVReportLink = /^depreciation-nbv-report$/;
    var repairReportLink = /^repair-history-report$/;
    var oosHistoryLink = /^out-of-service-history$/;
    var contractRevenueReport = /^contract-revenue-report$/;
    var mileageUploadLink = /^mileage-upload$/;
    var mileageUploadDetailLink = /^mileage-upload-detail$/;
    var invoiceDetailReportLink = /^invoice-detail-report$/;
    var nonBillableUnitLink = /^non-billable-unit-report$/;
    var equipmentAccountingLink = /^equipment-accounting-records-report$/;
    var featureMap = /^feature-mapping$/;
    var systemParamLink = /^system-param$/;
    var jobPostingLink = /^job-posting$/;
    var subSystemLink = /^sub-system$/;
    var financeChargeInvExp = /^finance-charge$/;
    var programActivityLink = /^program-activity$/;
    var DebtNoteUnitDetailReport = /^debt-note-unit-report$/;
    var warrantyClaimReport = /^warranty-claim$/;
    var woInvoiceLink = /^workorder$/;
    var DebtNotePostingDetail = /^debt-note-posting-detail$/;
    var DebtNoteSchedule = /^debt-note-schedule$/;
    var leaveHolidayCalLink = /^leave-holiday$/;
    var typedeposit = /^asset-deposit-type$/;
    var subjectList = /^subject$/;
    var feedbackLink = /^issues-reported$/;
    var voucherPaymentLink = /^voucher-payment$/;
    var capitalCostAnalysisLink = /^capital-cost-analysis$/;
    var fhutExceptionLink = /^fhut-exception$/;
    var availableVehicleLink = /^available-vehicles$/;
    var myVehicleLink = /^my-vehicles$/;
    var addAssetLink = /^asset$/;
    var vehicleRegistrationTrackingLink = /^warrantyregistration$/
    var vehicleOrderFormLink = /^vehicle-order-form$/
    var vehicleOrderTrackingLink = /^vehicle-order$/
    var consumerExp = /^customer$/;
    var dealerExp = /^dealer$/;
    var allVehicleList = /^all-vehicles$/;
    var ratesList = /^rates$/;
    var srtExp = /^srt$/;
    var vehicleInformationLink = /^vehicle-information$/;
    var publication = /^publication$/;
    var campaign = /^campaign$/;
    var campaignRecallStatus = /^campaign-recall-status$/;
    var pdcStock = /^pdc-stock$/;
    var orderPart = /^part-order$/;
    var reportConcern = /^report-concern$/;
    var feedbackLog = /^feedback-log$/;
    var gallery = /^media-gallery$/;
    var technicalSupportRequest = /^technical-support-request$/;
    var technicalSupportQueue = /^technical-support-queue$/;
    var vehicleOption = /^vehicle-option$/;
    var retailDeliveryReport = /^retail-delivery-report$/;
    var availableVehicleLinkForOrder = /^available-vehicles-for-order$/;
    var partBackorderReport = /^part-backorder-report$/;
    var creditMemoLog = /^credit-memo-log$/;
    var positionCode = /^position-code$/;
    var damageCode = /^damage-code$/;


    var velocity_env = process.env.NODE_ENV;
    var isEv = true;
    var self = this;

    if(velocity_env == 'velev' || velocity_env == 'velev_test'){
      isEv = true;
    }else{
      isEv = false;
    }

    // alert(reservationRentalTabLink.test(pathArr[1]+'/'+pathArr[2]));
    var visitedPath = [];
    if (!path.includes("edit")) {

      // EventBus.$emit("visited_page");
    }

    setTimeout(function () {

      $("#menu li").removeClass("active")
      $("#menu ul").removeClass("d-block")
      $('#menu ul').hide();

      //main manus
      if (!isEv) {
        if (woInvoiceLink.test(pathArr[1]) && pathArr[2] == "invoice") {
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#woInvoiceLink").addClass('active');
        } else if (estimateLink.test(pathArr[1]) || custEstimateLink.test(pathArr[1]) || venEstimateLink.test(pathArr[1])) {
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#workOrderEstimateLink").addClass('active');
        } else if (venPurchaseOrderLink.test(pathArr[1])) {
          $("#assetTabLink a").click();
          $("#assetTabLink").addClass('active');
          $("#purchaseorderassetdetailLink").addClass('active');
        } else if (priceBookLink.test(pathArr[1])) {
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#defaultpricebookLink").addClass('active');
        } else if (pricebookhistoryLink.test(pathArr[1])) {
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#pricebookhistoryLink").addClass('active');
        } else if (laborCostLink.test(pathArr[1])) {
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#laborCostLink").addClass('active');
        } else if (vehiclelogLink.test(pathArr[1])) {

          $("#assetTabLink a").click();
          $("#assetTabLink").addClass('active');
          $("#vehiclelogLink").addClass('active');

        } else if (vehiclesaleLink.test(pathArr[1])) {

          $("#assetTabLink a").click();
          $("#assetTabLink").addClass('active');
          $("#vehiclesaleLink").addClass('active');

        } else if (vendorPOLink.test(pathArr[1])) {

          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#purchaseorderdetailLink").addClass('active');
        } else if (suggestedOrderLink.test(pathArr[1])) {

          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#suggestedOrderLink").addClass('active');
        } else if ((purchaseOrderLink.test(pathArr[1]) || custPurchaseOrderLink.test(pathArr[1])) && (self.$route.query.type == undefined || self.$route.query.type != 'contract')) {//
          console.log("URL vendor =", self.$route.query.type);
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#purchaseorderdetailLink").addClass('active');

        } else if (purchaseOrderLink.test(pathArr[1]) && self.$route.query.type == 'contract' && self.$route.query.by != 'rent') {
          console.log("URL customer =", self.$route.query.type);
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#customerpurchaseorderdetailLink").addClass('active');

        } else if (rentalPOLink.test(pathArr[1]) && self.$route.query.type != undefined && self.$route.query.type == 'contract' && self.$route.query.by == 'rent') {
          $("#rentalTabLink a").click();
          $("#rentalTabLink").addClass('active');
          $("#rentalpoLink").addClass('active');

        } else if (purchaseorderassetdetailLink.test(pathArr[1]) && self.$route.query.from != undefined && self.$route.query.from == 'asset') {

          $("#assetTabLink a").click();
          $("#assetTabLink").addClass('active');
          $("#purchaseorderassetdetailLink").addClass('active');

        } else if (workordertemplateLink.test(pathArr[1])) {

          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#workordertemplateLink").addClass('active');

        } else if (crmExp.test(pathArr[1])) {

          $("#crmLink").addClass('active');

        } else if (notesExp.test(pathArr[1])) {

          $("#notesLink").addClass('active');

        } else if (billLink.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#billLink").addClass('active');
          $("#accountGlLink a").click();
          $("#accountRecLink a").click();
          $("#accountingReportsLink a").click();

        } else if (depreciationLink.test(pathArr[1]) || depreciationSchLink.test(pathArr[1])) {
          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#depreciationLink").addClass('active');
          $("#accountGlLink a").click();
          $("#accountRecLink a").click();
          $("#accountPayLink a").click();
          $("#accountingReportsLink a").click();

        } else if (bankTransferLink.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#bankTransferLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountRecLink a").click();
          $("#accountGlLink a").click();
          $("#accountingReportsLink a").click();

        } else if (bankSummaryLink.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#bankSummaryLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountRecLink a").click();
          $("#accountGlLink a").click();
          $("#accountingReportsLink a").click();

        } else if (glBalanceLink.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#glBalanceLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountRecLink a").click();
          $("#accountGlLink a").click();
          $("#accountingReportsLink a").click();

        } else if (subSystemLink.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#subSystemLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountRecLink a").click();
          $("#accountGlLink a").click();
          $("#accountingReportsLink a").click();

        } else if (debtNoteList.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#debtNoteList").addClass('active');
          $("#accountRecLink a").click();
          $("#accountGlLink a").click();
          $("#accountingReportsLink a").click();

        } else if (debtPaymentReconciliation.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#debtPaymentReconciliation").addClass('active');
          $("#accountRecLink a").click();
          $("#accountGlLink a").click();
          $("#accountingReportsLink a").click();

        } else if (invoiceExp.test(pathArr[1]) || financeChargeInvExp.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#invoiceLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountGlLink a").click();
          $("#accountingReportsLink a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#invoiceLink").addClass('active');

        } else if (refundPaymentListExp.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#refundPaymentList").addClass('active');
          $("#accountPayLink a").click();
          $("#accountGlLink a").click();
          $("#accountingReportsLink a").click();

        } else if (refundEligibleListExp.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#refundEligibleList").addClass('active');
          $("#accountPayLink a").click();
          $("#accountGlLink a").click();
          $("#accountingReportsLink a").click();

        } else if (accountReceivableInquiryExp.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#accountReceivableInquiry").addClass('active');
          $("#accountPayLink a").click();
          $("#accountGlLink a").click();
          $("#accountingReportsLink a").click();

        } else if (agreementInvExp.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#invoiceLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountGlLink a").click();
          $("#accountingReportsLink a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#invoiceLink").addClass('active');

        } else if (paymentExp.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#paymentLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountGlLink a").click();
          $("#accountingReportsLink a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#paymentLink").addClass('active');

        } else if (receiptLink.test(pathArr[1]) || receiptItemLink.test(pathArr[1]) || receiptInvoiceLink.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#receiptLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountGlLink a").click();
          $("#accountingReportsLink a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#paymentLink").addClass('active');

        } else if (statementLink.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#statementLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountGlLink a").click();
          $("#accountingReportsLink a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#paymentLink").addClass('active');

        } else if (glAccountLink.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#glaccountLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountRecLink a").click();
          $("#accountingReportsLink a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#glaccountLink").addClass('active');

        } else if (creditNoteLink.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#creditNoteLink").addClass('active');
          $("#accountGlLink a").click();
          $("#accountRecLink a").click();
          $("#accountingReportsLink a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#creditNoteLink").addClass('active');
        } else if (vendorPaymentLink.test(pathArr[1]) && urlParams.get('flag') == 'reports') {

          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#vendorPaymentLink").addClass('active');
          $("#AccountReceivableReport a").click();
          $("#GeneralLedgerReport a").click();

        } else if (vendorPaymentLink.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#vendorPaymentLink").addClass('active');
          $("#accountGlLink a").click();
          $("#accountRecLink a").click();
          $("#accountingReportsLink a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#creditNoteLink").addClass('active');

        } else if (journalLink.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#journalLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountRecLink a").click();
          $("#accountingReportsLink a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#journalLink").addClass('active');

        } else if (journalRecurringLink.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#journalRecurringLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountRecLink a").click();
          $("#accountingReportsLink a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#journalLink").addClass('active');

        } else if (glReportLink.test(pathArr[2])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#generalLedgerLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountRecLink a").click();
          $("#accountingReportsLink a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#journalLink").addClass('active');

        } else if (wrongGlAccountsLink.test(pathArr[1])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#wrongGlAccountsLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountRecLink a").click();
          $("#accountingReportsLink a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#journalLink").addClass('active');

        } else if (taxSummaryLink.test(pathArr[2])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#taxSummaryLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountRecLink a").click();
          $("#accountGlLink a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#journalLink").addClass('active');

        } else if (incomeSummaryLink.test(pathArr[2])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#incomeSummaryLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountRecLink a").click();
          $("#accountGlLink a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#journalLink").addClass('active');

        } else if (expenseSummaryLink.test(pathArr[2])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#expenseSummaryLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountRecLink a").click();
          $("#accountGlLink a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#journalLink").addClass('active');

        } else if (profitLossLink.test(pathArr[2])) {

          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#profitLossLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountRecLink a").click();
          $("#accountGlLink a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#journalLink").addClass('active');

        } else if (trialBalanceLink.test(pathArr[2])) {

          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#trialBalanceLink").addClass('active');
          $("#AccountReceivableReport a").click();
          $("#AccountPayableReport a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#journalLink").addClass('active');

        } else if (subletInProcessLink.test(pathArr[1])) {

          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#subletInProcessLink").addClass('active');
          $("#AccountReceivableReport a").click();
          $("#AccountPayableReport a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#journalLink").addClass('active');

        } else if (fuelInventoryClearingLink.test(pathArr[1])) {

          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#fuelInventoryClearingLink").addClass('active');
          $("#AccountReceivableReport a").click();
          $("#AccountPayableReport a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#journalLink").addClass('active');

        } else if (accruedLiabilityLink.test(pathArr[1])) {

          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#accruedLiabilityLink").addClass('active');
          $("#AccountReceivableReport a").click();
          $("#AccountPayableReport a").click();

          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#journalLink").addClass('active');
        } else if (customerAROutstandingLink.test(pathArr[2])) {

          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#customerAROutstandingLink").addClass('active');
          $("#GeneralLedgerReport a").click();
          $("#AccountPayableReport a").click();
          // $("#accountTabLink a").click();
          // $("#accountTabLink").addClass('active');
          // $("#journalLink").addClass('active');

        } else if (unitReadingListExp.test(pathArr[1])) {
          $("#noticeTabLink a").click();
          $("#noticeTabLink").addClass('active');
          $("#unitReadinglistlink").addClass('active');
        } else if (transportrequestExp.test(pathArr[1]) || transportReqLink.test(pathArr[1])) {
          $("#transportRequestLink").addClass('active');
        } else if (potentialCancellation.test(pathArr[1])) {
          $("#potentialCancellationLink").addClass('active');
        } else if (rentalCancellation.test(pathArr[1])) {
          $("#rentalCancellationLink").addClass('active');
        } else if (activity.test(pathArr[1])) {
          $("#activityLink").addClass('active');
        } else if (importLink.test(pathArr[1])) {
          $("#importDLink a").click();
          $("#importDLink").addClass('active');
          $("#importDataLink").addClass('active');
        } else if (odometerLink.test(pathArr[1])) {
          $("#odometerlistlink").addClass('active');
        } else if (mileageUploadLink.test(pathArr[1]) || mileageUploadDetailLink.test(pathArr[1])) {
          $("#mileageUploadLink").addClass('active');
        } else if (customerExp.test(pathArr[1])) {
          $("#customerTabLink a").click();
          $("#customerTabLink").addClass('active');
          $("#customerLink").addClass('active');
        } else if (customercontactExp.test(pathArr[1])) {
          $("#customerTabLink a").click();
          $("#customerTabLink").addClass('active');
          $("#customercontactLink").addClass('active');
        } else if (userExpr.test(pathArr[1])) {
          $("#userLink").addClass('active');
        } else if (vendorExp.test(pathArr[1])) {
          $("#vendorLink").addClass('active');
          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#accountGlLink a").click();
          $("#accountRecLink a").click();
          $("#accountingReportsLink a").click();
        } else if (checkLink.test(pathArr[1])) {
          $("#checkLink").addClass('active');
          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#accountGlLink a").click();
          $("#accountRecLink a").click();
          $("#accountingReportsLink a").click();
        } else if (voucherPaymentLink.test(pathArr[1])) {
          $("#voucherPaymentMaintenanceLink").addClass('active');
          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#accountGlLink a").click();
          $("#accountRecLink a").click();
          $("#accountingReportsLink a").click();
        }
        // else if ( reservationExp.test(pathArr[1])) {
        //     $("#reservationLink").addClass('active');
        // }
        else if (pendingreservationExp.test(pathArr[1])) {
          $("#pendingreservationLink").addClass('active');
        } else if (unsyncDataExp.test(pathArr[1])) {
          $("#unsyncedLink").addClass('active');
        } else if (vehicleExp.test(pathArr[1])) {
          $("#assetTabLink a").click();
          $("#assetTabLink").addClass('active');
          $("#vehicleLink").addClass('active');
        } else if (assetcomponent.test(pathArr[1])) {
          $("#assetTabLink a").click();
          $("#assetcomponent").addClass('active');
          $("#assetTabLink").addClass('active');
        } else if (requisitionLink.test(pathArr[1])) {
          $("#assetTabLink a").click();
          $("#assetTabLink").addClass('active');
          $("#requisitionLink").addClass('active');

        } else if (vehiclehvutLink.test(pathArr[1])) {
          $("#permitTabLink a").click();
          $("#permitTabLink").addClass('active');
          $("#vehiclehvutLink").addClass('active');
        } else if (fhutCategoryLink.test(pathArr[1])) {
          $("#permitTabLink a").click();
          $("#permitTabLink").addClass('active');
          $("#fhutCategoryLink").addClass('active');
        } else if (citationLink.test(pathArr[1])) {
          $("#permitTabLink a").click();
          $("#permitTabLink").addClass('active');
          $("#citationLink").addClass('active');
        } else if (capitalCostAnalysisLink.test(pathArr[1])) {
          $("#assetTabLink a").click();
          $("#assetTabLink").addClass('active');
          $("#capitalCostAnalysisLink").addClass('active');
        } else if (assetfeature.test(pathArr[1])) {
          $("#assetTabLink a").click();
          $("#assetfeature").addClass('active');
          $("#assetTabLink").addClass('active');
        } else if (enquiryExp.test(pathArr[1])) {
          $("#enquiryLink").addClass('active');
        } else if (vehicleLocationHistoryExp.test(pathArr[1])) {
          $("#vehiclelocationhistoryLink").addClass('active');
        } else if (vehicleContractHistoryExp.test(pathArr[1])) {
          $("#vehiclecontracthistoryLink").addClass('active');
        } else if (vehicleDefectsExp.test(pathArr[1])) {

          $("#assetTabLink a").click();
          $("#assetTabLink").addClass('active');
          $("#vehicledefectLink").addClass('active');

        } else if (importDataReviewLink.test(pathArr[1])) {
          $("#importDLink a").click();
          $("#importDLink").addClass('active');
          $("#importDataReviewLink").addClass('active');
        } else if (workOrderLink.test(pathArr[1])) {
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#workOrderLink").addClass('active');
        } else if (approvedWOLink.test(pathArr[1])) {
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#approvedWorkOrderLink").addClass('active');
        } else if (shiftDetailLink.test(pathArr[1])) {
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#shiftDetailLink").addClass('active');
        } else if (vmrsLink.test(pathArr[1])) {
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#vmrsLink").addClass('active');
        } else if (unitReadingsExp.test(pathArr[1])) {
          $("#unitReadingslistlink").addClass('active');
        } else if (recallAssetMapperLink.test(pathArr[1])) {
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#recallAssetMapperLink").addClass('active');
        } else if (groupExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#groupLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (subjectList.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#subjectList").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (vehicleStatusExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#settingLink").addClass('active');
          $("#vehicleStatusLink").addClass('active');
          $("#settingContractLink a").click();
          $("#settingComponentLink a").click();
          $("#settingFuelLink a").click();

        } else if (vehicleTypeExp.test(pathArr[1])) {
          $("#assetTabLink a").click();
          $("#assetTabLink").addClass('active');
          $("#vehicleTypeLink").addClass('active');


        } else if (grantPermissionTypeExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#grantPermissionLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (permissionExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#permissionLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (roleExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#roleLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (workOrderExp.test(pathArr[1])) {
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#workOrderTabLink").addClass('active');
        } else if (measurementExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#measurementUnitLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (vehicleManufacturerExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#settingLink").addClass('active');
          $("#vehicleManufacturerLink").addClass('active');
          $("#settingContractLink a").click();
          $("#settingComponentLink a").click();
          $("#settingFuelLink a").click();
        } else if (vehicleModelExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#settingLink").addClass('active');
          $("#vehicleModelLink").addClass('active');
          $("#settingContractLink a").click();
          $("#settingComponentLink a").click();
          $("#settingFuelLink a").click();
        } else if (vehicleGroupExp.test(pathArr[1])) {
          $("#assetTabLink a").click();
          $("#assetTabLink").addClass('active');
          $("#vehicleGroupLink").addClass('active');
        } else if (vehicleOwnershipExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#settingLink").addClass('active');
          $("#vehicleOwnershipLink").addClass('active');
          $("#settingContractLink a").click();
          $("#settingComponentLink a").click();
          $("#settingFuelLink a").click();
        } else if (vehiclePoolExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#settingLink").addClass('active');
          $("#vehiclePoolLink").addClass('active');
          $("#settingContractLink a").click();
          $("#settingComponentLink a").click();
          $("#settingFuelLink a").click();
        } else if (fuelPricingLink.test(pathArr[1])) {
          $("#fuelTabLink a").click();
          $("#fuelTabLink").addClass('active');
          $("#fuelPricingLink").addClass('active');
        } else if (fuelPriceLogLink.test(pathArr[1])) {
          $("#fuelTabLink a").click();
          $("#fuelTabLink").addClass('active');
          $("#fuelPriceLogLink").addClass('active');
        } else if (fuelislandProductLink.test(pathArr[1])) {
          $("#fuelTabLink a").click();
          $("#fuelTabLink").addClass('active');
          $("#fuelislandProductLink").addClass('active');
        } else if (fuelTankPumpMapperLink.test(pathArr[1])) {
          $("#fuelTabLink a").click();
          $("#fuelTabLink").addClass('active');
          $("#fuelTankPumpMapperLink").addClass('active');
        } else if (fuelDropLink.test(pathArr[1])) {
          $("#fuelTabLink a").click();
          $("#fuelTabLink").addClass('active');
          $("#fuelDropLink").addClass('active');
        } else if (fuelTicketLink.test(pathArr[1])) {
          $("#fuelTabLink a").click();
          $("#fuelTabLink").addClass('active');
          $("#fuelTicketLink").addClass('active');
        } else if (fuelReadingLink.test(pathArr[1])) {
          $("#fuelTabLink a").click();
          $("#fuelTabLink").addClass('active');
          $("#fuelReadingLink").addClass('active');
        } else if (locationExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#locationLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (itemcategoriesExp.test(pathArr[1])) {
          // $("#settingLink a").click();
          // $("#settingLink").addClass('active');
          $("#inventoryTabLink a").click();
          $("#inventoryTabLink").addClass('active');
          $("#itemcategoryLink").addClass('active');
          // $("#settingContractLink a").click();
          // $("#settingAssetsLink a").click();
          // $("#settingFuelLink a").click();
        } else if (inventory.test(pathArr[1])) {
          $("#inventory").addClass('active');
        } else if (itemmanufacturerExp.test(pathArr[1])) {
          // $("#settingLink a").click();
          // $("#settingLink").addClass('active');
          $("#inventoryTabLink a").click();
          $("#inventoryTabLink").addClass('active');
          $("#itemManufacturerLink").addClass('active');
          // $("#settingContractLink a").click();
          // $("#settingAssetsLink a").click();
          // $("#settingFuelLink a").click();
        }
        //  else if ( warrantyExp.test(pathArr[1])) {
        //     $("#warrantyLink").addClass('active');
        // }
        else if (itemExp.test(pathArr[1])) {
          $("#inventoryTabLink a").click();
          $("#inventoryTabLink").addClass('active');
          $("#itemLink").addClass('active');
          // $("#settingContractLink a").click();
          // $("#settingAssetsLink a").click();
          // $("#settingFuelLink a").click();
        } else if (comptransaction.test(pathArr[1])) {
          $("#inventoryTabLink a").click();
          $("#inventoryTabLink").addClass('active');
          $("#compTransactionLink").addClass('active');
          // $("#settingContractLink a").click();
          // $("#settingAssetsLink a").click();
          // $("#settingFuelLink a").click();
        } else if (compinventory.test(pathArr[1])) {
          $("#inventoryTabLink a").click();
          $("#inventoryTabLink").addClass('active');
          $("#compTransactionLink").addClass('active');
        } else if (venItemPurchaseOrderLink.test(pathArr[1])) {
          $("#inventoryTabLink a").click();
          $("#inventoryTabLink").addClass('active');
          $("#itemPurchageOrderLink").addClass('active');
          // $("#settingContractLink a").click();
          // $("#settingAssetsLink a").click();
          // $("#settingFuelLink a").click();
        } else if (poreceipt.test(pathArr[1])) {
          $("#inventoryTabLink a").click();
          $("#inventoryTabLink").addClass('active');
          $("#poreceiptLink").addClass('active');
          // $("#settingContractLink a").click();
          // $("#settingAssetsLink a").click();
          // $("#settingFuelLink a").click();
        } else if (warehouseExp.test(pathArr[1])) {
          // $("#settingLink a").click();
          // $("#settingLink").addClass('active');
          $("#inventoryTabLink a").click();
          $("#inventoryTabLink").addClass('active');
          $("#warehouseLink").addClass('active');
          // $("#settingContractLink a").click();
          // $("#settingAssetsLink a").click();
          // $("#settingFuelLink a").click();
        } else if (warehouseBinMapperLink.test(pathArr[1])) {
          // $("#settingLink a").click();
          // $("#settingLink").addClass('active');
          $("#inventoryTabLink a").click();
          $("#inventoryTabLink").addClass('active');
          $("#warehouseBinMapperLink").addClass('active');
          // $("#settingContractLink a").click();
          // $("#settingAssetsLink a").click();
          // $("#settingFuelLink a").click();

        } else if (cpicodeExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#settingLink").addClass('active');
          $("#cpicodeLink").addClass('active');
          $("#settingAssetsLink a").click();
          $("#settingComponentLink a").click();
          $("#settingFuelLink a").click();
        } else if (contractbillingmethodExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#settingLink").addClass('active');
          $("#contractbillingmethodLink").addClass('active');
          $("#settingAssetsLink a").click();
          $("#settingComponentLink a").click();
          $("#settingFuelLink a").click();
        } else if (contractbillingfrequencyExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#settingLink").addClass('active');
          $("#contractbillingfrequencyLink").addClass('active');
          $("#settingAssetsLink a").click();
          $("#settingComponentLink a").click();
          $("#settingFuelLink a").click();
        } else if (customerclassExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#customerclassLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (representativeExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#representativeLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (contracttypeExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#settingLink").addClass('active');
          $("#contracttypeLink").addClass('active');
          $("#settingAssetsLink a").click();
          $("#settingComponentLink a").click();
          $("#settingFuelLink a").click();
        } else if (contracttypesectionmapperExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#settingLink").addClass('active');
          $("#contracttypesectionmapperLink").addClass('active');
          $("#settingAssetsLink a").click();
          $("#settingComponentLink a").click();
          $("#settingFuelLink a").click();
        } else if (termExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#termLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (metrictypeExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#metrictypeLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (vehiclemaintanancereportingstandardsExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#settingLink").addClass('active');
          $("#vehiclemaintanancereportingstandardsLink").addClass('active');
          $("#settingContractLink a").click();
          $("#settingComponentLink a").click();
          $("#settingFuelLink a").click();
        } else if (insurancecompanyExp.test(pathArr[1])) {
          $("#insuranceTabLink a").click();
          $("#insuranceTabLink").addClass('active');
          $("#insurancecompanyLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (maintenanceScheduleExp.test(pathArr[1])) {
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#scheduleTabLink").addClass('active');
        } else if (rentalagreementExp.test(pathArr[1])) {
          $("#rentalTabLink a").click();
          $("#rentalTabLink").addClass('active');
          $("#rentalagreementLink").addClass('active');
        } else if (contractExp.test(pathArr[1])) {
          $("#leaseTabLink a").click();
          $("#leaseTabLink").addClass('active');
          $("#contractLink").addClass('active');
        } else if (contractunitdetailExp.test(pathArr[1])) {
          $("#leaseTabLink a").click();
          $("#leaseTabLink").addClass('active');
          $("#contractunitdetailLink").addClass('active');
        } else if (effectivecpirateExp.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#settingLink").addClass('active');
          $("#effectivecpirateLink").addClass('active');
          $("#settingAssetsLink a").click();
          $("#settingComponentLink a").click();
          $("#settingFuelLink a").click();
        } else if (cpiproofreviewExp.test(pathArr[1])) {
          $("#leaseTabLink a").click();
          $("#leaseTabLink").addClass('active');
          $("#cpiproofreviewLink").addClass('active');
        } else if (dashboardExp.test(pathArr[1])) {
          $("#dashboardLink").addClass('active');
        } else if (cpiacknowledgementExp.test(pathArr[1])) {
          //$("#settingLink a").click();
          $("#cpiacknowledgementmailsentLink").addClass('active');
        } else if (creditdetails.test(pathArr[1])) {
          //$("#settingLink a").click();
          $("#customerTabLink a").click();
          $("#customerTabLink").addClass('active');
          $("#creditLink").addClass('active');
        } else if (achdetails.test(pathArr[1])) {
          //$("#settingLink a").click();
          $("#customerTabLink a").click();
          $("#customerTabLink").addClass('active');
          $("#achLink").addClass('active');
        } else if (typedeposit.test(pathArr[1])) {
          //$("#settingLink a").click();
          $("#customerTabLink a").click();
          $("#customerTabLink").addClass('active');
          $("#typedeposit").addClass('active');
        } else if (inq.test(pathArr[1])) {
          //$("#settingLink a").click();
          $("#enquiryLink").addClass('active');
        } else if (needs.test(pathArr[1])) {
          //$("#settingLink a").click();
          $("#needsLink").addClass('active');
        } else if (feedbackLink.test(pathArr[1])) {
          //$("#settingLink a").click();
          $("#feedbackLink").addClass('active');
        } else if (scoperate.test(pathArr[1])) {
          //$("#scopeheaderLink a").click();
          //$("#scopeheaderLink").addClass('active');
          $("#rentalTabLink a").click();
          $("#rentalTabLink").addClass('active');
          $("#scoperateLink").addClass('active');
        } else if (scopeheaderLink.test(pathArr[1])) {
          $("#rentalTabLink a").click();
          $("#rentalTabLink").addClass('active');
          //$("#scopeheaderLink a").click();
          //$("#scopeheaderLink").addClass('active');
          $("#scopeheaderrateLink").addClass('active');
        } else if (customerdiscountLink.test(pathArr[1])) {
          $("#rentalTabLink a").click();
          $("#rentalTabLink").addClass('active');
          //$("#scopeheaderLink a").click();
          //$("#scopeheaderLink").addClass('active');
          $("#customerdiscountLink").addClass('active');
        } else if (permitType.test(pathArr[1])) {
          $("#permitTabLink a").click();
          $("#permitTabLink").addClass('active');
          $("#vehiclepermittypeLink").addClass('active');
        } else if (permit.test(pathArr[1])) {
          $("#permitTabLink a").click();
          $("#permitTabLink").addClass('active');
          $("#vehiclepermitLink").addClass('active');
          // $("#settingContractLink a").click();
          // $("#settingComponentLink a").click();
        } else if (featureCat.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#settingLink").addClass('active');
          $("#assetfeaturecategory").addClass('active');
          $("#settingContractLink a").click();
          $("#settingComponentLink a").click();
          $("#settingFuelLink a").click();
        } else if (feature.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#settingLink").addClass('active');
          $("#assetfeatures").addClass('active');
          $("#settingContractLink a").click();
          $("#settingComponentLink a").click();
          $("#settingFuelLink a").click();
        } else if (standardFeature.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#settingLink").addClass('active');
          $("#assetstandardfeatures").addClass('active');
          $("#settingContractLink a").click();
          $("#settingComponentLink a").click();
        } else if (reservationRentalTabLink.test(pathArr[1] + '/' + pathArr[2])) {
          $("#rentalTabLink a").click();
          $("#rentalTabLink").addClass('active');
          $("#reservationRentalTabLink").addClass('active');
        } else if (reservationLeaseTabLink.test(pathArr[1] + '/' + pathArr[2])) {
          $("#leaseTabLink a").click();
          $("#leaseTabLink").addClass('active');
          $("#reservationLeaseTabLink").addClass('active');
        } else if (servicesExp.test(pathArr[1])) {
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          // } else if ( reportExp.test(pathArr[1])) {
          // $("#reportTabLink a").click();
          // $("#reportTabLink").addClass('active');
          //$("#reservationRentalTabLink a").addClass('active');
        } else if (leaveHolidayCalLink.test(pathArr[1])) {
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#leaveHolidayTabLink").addClass('active');
        } else if (sentMailLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#sentMailLink").addClass('active');
        } else if (mailReportLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#mailReportLink").addClass('active');
        } else if (customerLoginLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#EMMSTabLink a").click();
          $("#EMMSTabLink").addClass('active');
          $("#EquipmentReport a").click();
          $("#PMSReport a").click();
          $("#ETKReport a").click();
          $("#MaterialReport a").click();
          $("#MaintenanceReport a").click();
          $("#customerLoginReportLink").addClass('active');
        } else if (repairReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#EMMSTabLink a").click();
          $("#EMMSTabLink").addClass('active');
          $("#EquipmentReport a").click();
          $("#PMSReport a").click();
          $("#ETKReport a").click();
          $("#MaterialReport a").click();
          $("#repairReportLink").addClass('active');
          $("#CustomerReport a").click();
        } else if (oosHistoryLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#EMMSTabLink a").click();
          $("#EMMSTabLink").addClass('active');
          $("#EquipmentReport a").click();
          $("#PMSReport a").click();
          $("#ETKReport a").click();
          $("#MaterialReport a").click();
          $("#oosHistoryLink").addClass('active');
          $("#CustomerReport a").click();
        } else if (vehicleFeatureReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#EMMSTabLink a").click();
          $("#EMMSTabLink").addClass('active');
          $("#vehicleFeatureReportLink").addClass('active');
          $("#ETKReport a").click();
          $("#PMSReport a").click();
          $("#MaterialReport a").click();
          $("#MaintenanceReport a").click();
          $("#CustomerReport a").click();
        } else if (courtesyNoticeLink.test(pathArr[2])) {
          $("#noticeTabLink a").click();
          $("#noticeTabLink").addClass('active');
          $("#courtesyNoticeLink").addClass('active');
        } else if (noticeACHlistlink.test(pathArr[2])) {
          $("#noticeTabLink a").click();
          $("#noticeTabLink").addClass('active');
          $("#noticeACHlistlink").addClass('active');
        } else if (pastDueNoticeLink.test(pathArr[2])) {
          $("#noticeTabLink a").click();
          $("#noticeTabLink").addClass('active');
          $("#pastDueNoticeLink").addClass('active');
        } else if (customerRegisterLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#EMMSTabLink a").click();
          $("#EMMSTabLink").addClass('active');
          $("#EquipmentReport a").click();
          $("#PMSReport a").click();
          $("#ETKReport a").click();
          $("#MaterialReport a").click();
          $("#MaintenanceReport a").click();
          $("#customerRegisterReportLink").addClass('active');
        } else if (customerInvoiceLineDetail.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#EMMSTabLink a").click();
          $("#EMMSTabLink").addClass('active');
          $("#EquipmentReport a").click();
          $("#PMSReport a").click();
          $("#ETKReport a").click();
          $("#MaterialReport a").click();
          $("#MaintenanceReport a").click();
          $("#customerInvoiceLineDetail").addClass('active');
        } else if (menuoverdueLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#menuoverdueLink").addClass('active');
        } else if (customerInteractionLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#customerInteractionReportLink").addClass('active');
        } else if (utilizeAssetLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#utilizeAssetReportLink").addClass('active');
        } else if (chargeCodeAccountLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#chargeCodeAccountLink").addClass('active');
        } else if (billingForecastLink.test(pathArr[1])) {
          $("#accountTabLink a").click();
          $("#accountTabLink").addClass('active');
          $("#billingForecastReportLink").addClass('active');
          $("#accountPayLink a").click();
          $("#accountGlLink a").click();
          $("#accountingReportsLink a").click();
        } else if (potentialCancellationLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#potentialCancellationLink").addClass('active');
        } else if (rentalCancellationLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#rentalCancellationLink").addClass('active');
        } else if (rentalActivityLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#rentalActivityLink").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#ContractReport a").click();

        } else if (actionAuditReport.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#RentalReport a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#actionAuditReport").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#ContractReport a").click();
        } else if (rentalActivityRatesLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#rentalActivityRatesLink").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#ContractReport a").click();
        } else if (substituteLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#substituteLink").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#ContractReport a").click();
        } else if (currentInsuranceLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#currentInsuranceLink").addClass('active');
          $("#ContractReport a").click();
          $("#BillingReport a").click();
          $("#RentalReport a").click();
        } else if (agedTrialBalSummaryLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#agedTrialBalSummaryLink").addClass('active');
          $("#GeneralLedgerReport a").click();
          $("#AccountPayableReport a").click();
        } else if (agedTrialBalDetailLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#agedTrialBalDetailLink").addClass('active');
          $("#GeneralLedgerReport a").click();
          $("#AccountPayableReport a").click();
        } else if (PMUnitDetailLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#EMMSTabLink a").click();
          $("#EMMSTabLink").addClass('active');
          $("#PMUnitDetailLink").addClass('active');
          $("#EquipmentReport a").click();
          $("#ETKReport a").click();
          $("#MaterialReport a").click();
          $("#CustomerReport a").click();
          $("#MaintenanceReport a").click();
        }
        else if ( warrantyClaimReport.test(pathArr[1])) {
            $("#reportTabLink a").click();
            $("#reportTabLink").addClass('active');
            $("#EMMSTabLink a").click();
            $("#EMMSTabLink").addClass('active');
            $("#warrantyClaimReport").addClass('active');
            $("#EquipmentReport a").click();
            $("#ETKReport a").click();
            $("#PMSReport a").click();
            $("#MaterialReport a").click();
            $("#CustomerReport a").click();
            $("#MaintenanceReport a").click();
        }
        else if (PMUnitForecastLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#EMMSTabLink a").click();
          $("#EMMSTabLink").addClass('active');
          $("#EquipmentReport a").click();
          $("#ETKReport a").click();
          $("#MaterialReport a").click();
          $("#CustomerReport a").click();
          $("#PMUnitForecastLink").addClass('active');
          $("#MaintenanceReport a").click();
        } else if (PMComplianceFacilityLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#EMMSTabLink a").click();
          $("#EMMSTabLink").addClass('active');
          $("#EquipmentReport a").click();
          $("#ETKReport a").click();
          $("#MaterialReport a").click();
          $("#CustomerReport a").click();
          $("#PMComplianceFacilityLink").addClass('active');
          $("#MaintenanceReport a").click();
        } else if (PMCompliancePoolLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#EMMSTabLink a").click();
          $("#EMMSTabLink").addClass('active');
          $("#EquipmentReport a").click();
          $("#ETKReport a").click();
          $("#MaterialReport a").click();
          $("#CustomerReport a").click();
          $("#PMCompliancePoolLink").addClass('active');
          $("#MaintenanceReport a").click();
        } else if (billingReadingForPeriod.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#billingReadingForPeriod").addClass('active');
          $("#ContractReport a").click();
          $("#LRInsuranceReport a").click();
          $("#RentalReport a").click();
        } else if (notePadReviewLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#notePadReviewLink").addClass('active');
          $("#GeneralLedgerReport a").click();
          $("#AccountPayableReport a").click();
        } else if (agedTrialBalanceDetailGridLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#agedTrialBalanceDetailGridLink").addClass('active');
          $("#GeneralLedgerReport a").click();
          $("#AccountPayableReport a").click();
        } else if (apTrialBalanceAsAtDetailLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#apTrialBalanceAsAtDetailLink").addClass('active');
          $("#AccountReceivableReport a").click();
          $("#GeneralLedgerReport a").click();
        } else if (apVoucherDistributionLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#apVoucherDistributionLink").addClass('active');
          $("#AccountReceivableReport a").click();
          $("#GeneralLedgerReport a").click();
        } else if (apPositivePayLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#apPositivePayLink").addClass('active');
          $("#AccountReceivableReport a").click();
          $("#GeneralLedgerReport a").click();
        } else if (arReceiptAndApplicationLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#arReceiptAndApplicationLink").addClass('active');
          $("#AccountPayableReport a").click();
          $("#GeneralLedgerReport a").click();
        } else if (woAccountingTransactionLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#EMMSTabLink a").click();
          $("#EMMSTabLink").addClass('active');
          $("#woAccountingTransactionLink").addClass('active');
          $("#EquipmentReport a").click();
          $("#PMSReport a").click();
          $("#ETKReport a").click();
          $("#MaterialReport a").click();
          $("#CustomerReport a").click();

        } else if (openOnAccountCashLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#openOnAccountCashLink").addClass('active');
          $("#AccountPayableReport a").click();
          $("#GeneralLedgerReport a").click();
        } else if (invoiceDetailReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#GeneralLedgerReport a").click();
          $("#invoiceDetailReportLink").addClass('active');
          $("#AccountPayableReport a").click();
        } else if (unitProfitLossSummaryLink.test(pathArr[2])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#assetManagementTabLink a").click();
          $("#assetManagementTabLink").addClass('active');
          $("#unitProfitLossSummaryLink").addClass('active');
          $("#disposalReport a").click();
          $("#DebtNotesReport a").click();
          $("#AMEquipmentReport a").click();
          $("#depreciationReport a").click();
          $("#insuranceReport a").click();
          // $("#ownedEquipmentReportLink a").click();

        } else if (reservationRentalTabLink.test(pathArr[2])) {
          $("#reservationRentalTabLink").addClass('active');
        } else if (chargesLink.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#chargelink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (extrachargelink.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#extrachargelink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (shopLink.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#shopLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (insurancePolicyLink.test(pathArr[1])) {
          $("#insuranceTabLink a").click();
          $("#insuranceTabLink").addClass('active');
          $("#insurancePolicyLink").addClass('active');
        } else if (insuranceAgencyLink.test(pathArr[1])) {
          $("#insuranceTabLink a").click();
          $("#insuranceTabLink").addClass('active');
          $("#insuranceAgencyLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (standardDefectLink.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#standarddefectLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (reasonLink.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#reasonLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (checkListActionLink.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#checklistactionLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (companyInfoLink.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#companyInfoLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (faqLink.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#faq").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (newsLink.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#newsLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (featureMap.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#settingLink").addClass('class');
          $("#featureMapLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (systemParamLink.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#settingLink").addClass('class');
          $("#systemParamLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        } else if (jobPostingLink.test(pathArr[1])) {
          $("#jobPostingLink").addClass('active');
        } else if (accountSettingLink.test(pathArr[1])) {
          $("#settingLink a").click();
          $("#accountSettingLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        }
        else if (scheduleReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#schedulereportLink").addClass('active');
        } else if (customerReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#customerReportLink").addClass('active');
          $("#GeneralLedgerReport a").click();
          $("#AccountPayableReport a").click();
        } else if (customercontactReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#customercontactReportLink").addClass('active');
          $("#GeneralLedgerReport a").click();
          $("#AccountPayableReport a").click();
        } else if (insurancePolicyReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#assetManagementTabLink a").click();
          $("#assetManagementTabLink").addClass('active');
          $("#insurancePolicyReportLink").addClass('active');
          $("#disposalReport a").click();
          $("#AMEquipmentReport a").click();
          $("#DebtNotesReport a").click();
          $("#depreciationReport a").click();
          $("#revenueExpenseReport a").click();
        } else if (contractReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#contractReportLink").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#RentalReport a").click();
        } else if (cpirateverificationLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#cpirateverificationLink").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#RentalReport a").click();
        } else if (annualmetricvscontractmetric.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#annualmetricvscontractmetric").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#RentalReport a").click();
        } else if (metricvscontractmetric.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#metricvscontractmetric").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#RentalReport a").click();
        } else if (contractExpiryLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#contractExpiryLink").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#RentalReport a").click();
        } else if (ratesandutilreport.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#ratesandutilreport").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#RentalReport a").click();
        } else if (totalFleetReport.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#totalFleetReport").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#RentalReport a").click();
        } else if (contractExpiryNonTemplateLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#contractExpiryNonTemplateLink").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#RentalReport a").click();
        } else if (contractCustomerReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#contractCustomerReportLink").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#RentalReport a").click();
        } else if (contractEquipmentReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#contractEquipmentReportLink").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#RentalReport a").click();
        } else if (contractEquipUtilizationReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#contractEquipUtilizationReportLink").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#RentalReport a").click();
        } else if (unitsWithoutActiveContractsLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#unitsWithoutActiveContractsLink").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#RentalReport a").click();
        } else if (fuelTicketReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FuelBillingTabLink a").click();
          $("#FuelBillingTabLink").addClass('active');
          $("#fuelTicketReportLink").addClass('active');
        } else if (generalLedgerReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#generalLedgerReportLink").addClass('active');
          $("#AccountReceivableReport a").click();
          $("#AccountPayableReport a").click();
        } else if (vehicleReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#EMMSTabLink a").click();
          $("#EMMSTabLink").addClass('active');
          $("#vehicleReportLink").addClass('active');
          $("#ETKReport a").click();
          $("#PMSReport a").click();
          $("#MaterialReport a").click();
          $("#CustomerReport a").click();
          $("#MaintenanceReport a").click();
        } else if (costPerMetricReport.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#EMMSTabLink a").click();
          $("#EMMSTabLink").addClass('active');
          $("#costPerMetricReport").addClass('active');
          $("#ETKReport a").click();
          $("#PMSReport a").click();
          $("#MaterialReport a").click();
          $("#CustomerReport a").click();
          $("#MaintenanceReport a").click();
        } else if (invoiceReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#assetManagementTabLink a").click();
          $("#assetManagementTabLink").addClass('active');
          $("#invoiceReportLink").addClass('active');
          $("#insuranceReport a").click();
          $("#depreciationReport a").click();
          $("#AMEquipmentReport a").click();
          $("#DebtNotesReport a").click();
          $("#revenueExpenseReport a").click();
        } else if (invoiceListReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FinancialTabLink a").click();
          $("#FinancialTabLink").addClass('active');
          $("#GeneralLedgerReport a").click();
          $("#invoiceListReportLink").addClass('active');
          $("#AccountPayableReport a").click();
        } else if (rentalListReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#rentalListReportLink").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#ContractReport a").click();
        } else if (scoperateReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#scoperateReportLink").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#ContractReport a").click();
        } else if (availableEquipmentReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#availableEquipmentReportLink").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#ContractReport a").click();
        } else if (reservationReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#reservationReportLink").addClass('active');
          $("#BillingReport a").click();
          $("#LRInsuranceReport a").click();
          $("#ContractReport a").click();
        } else if (gangsheetReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#EMMSTabLink a").click();
          $("#EMMSTabLink").addClass('active');
          $("#gangsheetReportLink").addClass('active');
          $("#EquipmentReport a").click();
          $("#PMSReport a").click();
          $("#MaterialReport a").click();
          $("#CustomerReport a").click();
          $("#MaintenanceReport a").click();
        } else if (laborManageReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#EMMSTabLink a").click();
          $("#EMMSTabLink").addClass('active');
          $("#laborManageReportLink").addClass('active');
          $("#EquipmentReport a").click();
          $("#PMSReport a").click();
          $("#MaterialReport a").click();
          $("#CustomerReport a").click();
          $("#MaintenanceReport a").click();
        } else if (permitReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#permitReportLink").addClass('active');
        } else if (unitPermitReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FuelTaxTabLink a").click();
          $("#FuelTaxTabLink").addClass('active');
          $("#unitPermitReportLink").addClass('active');
        } else if (hvutUnitReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#FuelTaxTabLink a").click();
          $("#FuelTaxTabLink").addClass('active');
          $("#hvutUnitReportLink").addClass('active');
        } else if (nonBillableUnitLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#SupportReportLink a").click();
          $("#SupportReportLink").addClass('active');
          $("#nonBillableUnitLink").addClass('active');
        } else if (equipmentAccountingLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#SupportReportLink a").click();
          $("#SupportReportLink").addClass('active');
          $("#equipmentaccountingrecords").addClass('active');
        } else if (depreciationReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#assetManagementTabLink a").click();
          $("#assetManagementTabLink").addClass('active');
          $("#depreciationReportLink").addClass('active');
          $("#AMEquipmentReport a").click();
          $("#DebtNotesReport a").click();
          $("#disposalReport a").click();
          $("#insuranceReport a").click();
          $("#revenueExpenseReport a").click();
        } else if (debtNoteBalanceDetail.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#assetManagementTabLink a").click();
          $("#assetManagementTabLink").addClass('active');
          $("#debtNoteBalanceDetail").addClass('active');
          $("#disposalReport a").click();
          $("#AMEquipmentReport a").click();
          $("#depreciationReport a").click();
          $("#insuranceReport a").click();
          $("#revenueExpenseReport a").click();
        } else if (depreciationNBVReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#assetManagementTabLink a").click();
          $("#assetManagementTabLink").addClass('active');
          $("#depreciationNBVReportLink").addClass('active');
          $("#AMEquipmentReport a").click();
          $("#DebtNotesReport a").click();
          $("#disposalReport a").click();
          $("#insuranceReport a").click();
          $("#revenueExpenseReport a").click();
        } else if (equipmentPoolReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#assetManagementTabLink a").click();
          $("#assetManagementTabLink").addClass('active');
          $("#equipmentPoolReportLink").addClass('active');
          $("#disposalReport a").click();
          $("#DebtNotesReport a").click();
          $("#insuranceReport a").click();
          $("#depreciationReport a").click();
          $("#revenueExpenseReport a").click();
        } else if (ownedEquipmentReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#assetManagementTabLink a").click();
          $("#assetManagementTabLink").addClass('active');
          $("#ownedEquipmentReportLink").addClass('active');
          $("#DebtNotesReport a").click();
          $("#disposalReport a").click();
          $("#AMEquipmentReport a").click();
          $("#depreciationReport a").click();
          $("#insuranceReport a").click();
          $("#revenueExpenseReport a").click();
        } else if (metricsBilledReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#metricsBilledReportLink").addClass('active');
          $("#LRInsuranceReport a").click();
          $("#ContractReport a").click();
          $("#RentalReport a").click();
        } else if (equipmentCurrentStatusReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#assetManagementTabLink a").click();
          $("#assetManagementTabLink").addClass('active');
          $("#equipmentCurrentStatusReportLink").addClass('active');
          $("#DebtNotesReport a").click();
          $("#disposalReport a").click();
          $("#insuranceReport a").click();
          $("#depreciationReport a").click();
          $("#revenueExpenseReport a").click();
        } else if (DebtNoteUnitDetailReport.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#assetManagementTabLink a").click();
          $("#assetManagementTabLink").addClass('active');
          $("#DebtNoteUnitDetailReport").addClass('active');
          $("#disposalReport a").click();
          $("#AMEquipmentReport a").click();
          $("#depreciationReport a").click();
          $("#insuranceReport a").click();
          $("#revenueExpenseReport a").click();
        } else if (DebtNotePostingDetail.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#assetManagementTabLink a").click();
          $("#assetManagementTabLink").addClass('active');
          $("#DebtNotePostingDetail").addClass('active');
          $("#disposalReport a").click();
          $("#AMEquipmentReport a").click();
          $("#depreciationReport a").click();
          $("#insuranceReport a").click();
          $("#revenueExpenseReport a").click();
        } else if (DebtNoteSchedule.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#assetManagementTabLink a").click();
          $("#assetManagementTabLink").addClass('active');
          $("#DebtNoteSchedule").addClass('active');
          $("#disposalReport a").click();
          $("#AMEquipmentReport a").click();
          $("#depreciationReport a").click();
          $("#insuranceReport a").click();
          $("#revenueExpenseReport a").click();
        } else if (inventoryReportLink.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#EMMSTabLink a").click();
          $("#EMMSTabLink").addClass('active');
          $("#inventoryReportLink").addClass('active');
          $("#EquipmentReport a").click();
          $("#PMSReport a").click();
          $("#ETKReport a").click();
          $("#CustomerReport a").click();
          $("#MaintenanceReport a").click();
        } else if (batchLink.test(pathArr[1])) {
          // $("#settingLink a").click();
          $("#batchLink").addClass('active');
        } else if (workEntryLink.test(pathArr[1])) {
          $("#etkTabLink a").click();
          $("#etkTabLink").addClass('active');
          $("#workEntryLink").addClass('active');
        } else if (laborCodeLink.test(pathArr[1])) {
          $("#etkTabLink a").click();
          $("#etkTabLink").addClass('active');
          $("#laborCodeLink").addClass('active');
        } else if (userLogEntryLink.test(pathArr[1])) {
          $("#etkTabLink a").click();
          $("#etkTabLink").addClass('active');
          $("#userLogEntry").addClass('active');
        } else if (gangSheetLink.test(pathArr[1])) {
          $("#etkTabLink a").click();
          $("#etkTabLink").addClass('active');
          $("#gangSheetLink").addClass('active');
        } else if (warrantyExp.test(pathArr[1])) {
          $("#warrantyTabLink a").click();
          $("#warrantyTabLink").addClass('active');
          $("#warrantyLink").addClass('active');
        } else if (claimLink.test(pathArr[1])) {
          $("#warrantyTabLink a").click();
          $("#warrantyTabLink").addClass('active');
          $("#claimLink").addClass('active');
        } else if (collectionLink.test(pathArr[2])) {
          $("#warrantyTabLink a").click();
          $("#warrantyTabLink").addClass('active');
          $("#collectionLink").addClass('active');
        } else if (programLink.test(pathArr[1])) {
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#programLink").addClass('active');
        } else if (programActivityLink.test(pathArr[1])) {
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#programLink").addClass('active');
        } else if (oosLink.test(pathArr[1])) {
          $("#maintenanceTabLink a").click();
          $("#maintenanceTabLink").addClass('active');
          $("#oosLink").addClass('active');
        } else if (physicalCountLink.test(pathArr[1])) {
          $("#inventoryTabLink a").click();
          $("#inventoryTabLink").addClass('active');
          $("#physicalCountLink").addClass('active');
        } else if (netBillingMetricsForPeriod.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#netBillingMetricsForPeriod").addClass('active');
          $("#LRInsuranceReport a").click();
          $("#ContractReport a").click();
          $("#RentalReport a").click();
        } else if (contractRevenueReport.test(pathArr[1])) {
          $("#reportTabLink a").click();
          $("#reportTabLink").addClass('active');
          $("#LeaseRentalTabLink a").click();
          $("#LeaseRentalTabLink").addClass('active');
          $("#contractRevenueReport").addClass('active');
          $("#LRInsuranceReport a").click();
          $("#ContractReport a").click();
          $("#RentalReport a").click();
        } else if (weeklyRentalReportLink.test(pathArr[1])) {
          $("#TestingTabLink a").click();
          $("#TestingTabLink").addClass('active');
          $("#weeklyRentalReportLink").addClass('active');
        } else if (fhutExceptionLink.test(pathArr[1])) {
          $("#permitTabLink a").click();
          $("#permitTabLink").addClass('active');
          $("#fhutExceptionLink").addClass('active');
        }
      }else{
        if (dashboardExp.test(pathArr[1])) {
          $("#dashboardLink").addClass('active');
        }else if (
          availableVehicleLink.test(pathArr[1])
          ||
          availableVehicleLinkForOrder.test(pathArr[1])
        ) {
          $("#assetTabLink ul").addClass('d-block');
          $("#assetTabLink").addClass('active');
          $("#availableVehicleLink").addClass('active');
        } else if (addAssetLink.test(pathArr[1])) {
          $("#assetTabLink ul").addClass('d-block');
          $("#assetTabLink").addClass('active');
          var query = self.$route.query.from;
          if(query === 'available-vehicles'){
            $("#availableVehicleLink").addClass('active');
          }else if(query === 'asset-list'){
            $("#allVehicles").addClass('active');
          }else if(query === 'my-vehicles'){
            $("#myVehicleLink").addClass('active');
          }
        }else if (myVehicleLink.test(pathArr[1])) {
          $("#assetTabLink ul").addClass('d-block');
          $("#assetTabLink").addClass('active');
          $("#myVehicleLink").addClass('active');
        }else if (allVehicleList.test(pathArr[1])) {
          $("#assetTabLink ul").addClass('d-block');
          $("#assetTabLink").addClass('active');
          $("#allVehicles").addClass('active');
        }else if (vehicleRegistrationTrackingLink.test(pathArr[1])) {
          $("#warrantyTabLink ul").addClass('d-block');
          $("#warrantyTabLink").addClass('active');
          if(pathArr[2] === "list" || pathArr[2] === 'view'){
            $("#vehicleRegistrationTrackingLink").addClass('active');
          }else if(pathArr[2] == "add"){
            $("#vehicleRegistrationLink").addClass('active');
          }
        }else if (vehicleOrderFormLink.test(pathArr[1])) {
          $("#assetTabLink ul").addClass('d-block');
          $("#assetTabLink").addClass('active');
          $("#vehicleOrderFormLink").addClass('active');
        }else if (vehicleOrderTrackingLink.test(pathArr[1])) {
          $("#assetTabLink ul").addClass('d-block');
          $("#assetTabLink").addClass('active');
          $("#vehicleOrderTrackingLink").addClass('active');
        }else if (retailDeliveryReport.test(pathArr[1])) {
          $("#assetTabLink ul").addClass('d-block');
          $("#assetTabLink").addClass('active');
          $("#retailDeliveryLink").addClass('active');
        }
        else if (pdcStock.test(pathArr[1])) {
          $("#inventoryTabLink ul").addClass('d-block');
          $("#inventoryTabLink").addClass('active');
          $("#compTransactionLink").addClass('active');
        }
        else if (orderPart.test(pathArr[1])) {
          $("#inventoryTabLink ul").addClass('d-block');
          $("#inventoryTabLink").addClass('active');
          $("#partOrderFormLink").addClass('active');
        }else if (partBackorderReport.test(pathArr[1])) {
          $("#inventoryTabLink ul").addClass('d-block');
          $("#inventoryTabLink").addClass('active');
          $("#partOrderBackorderReport").addClass('active');
        }else if (purchaseOrderLink.test(pathArr[1])) {
          $("#inventoryTabLink ul").addClass('d-block');
          $("#inventoryTabLink").addClass('active');
          $("#partOrderListLink").addClass('active');
        } else if (warrantyExp.test(pathArr[1])) {
          $("#warrantyTabLink ul").addClass('d-block');
          $("#warrantyTabLink").addClass('active');
          $("#warrantyLink").addClass('active');
        }else if (claimLink.test(pathArr[1])) {
          $("#warrantyTabLink ul").addClass('d-block');
          $("#warrantyTabLink").addClass('active');
          $("#claimLink").addClass('active');
        } else if (collectionLink.test(pathArr[2])) {
          $("#warrantyTabLink ul").addClass('d-block');
          $("#warrantyTabLink").addClass('active');
          $("#collectionLink").addClass('active');
        }else if (crmExp.test(pathArr[1])) {
          $("#crmLink").addClass('active');
        } else if (activity.test(pathArr[1])) {
          $("#activityLink").addClass('active');
        }else if (userExpr.test(pathArr[1])) {
          $("#userLink").addClass('active');
        }else if (roleExp.test(pathArr[1])) {
          $("#settingLink ul").addClass('d-block');
          $("#roleLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        }else if (grantPermissionTypeExp.test(pathArr[1])) {
          $("#settingLink ul").addClass('d-block');
          $("#grantPermissionLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        }else if (locationExp.test(pathArr[1])) {
          $("#settingLink ul").addClass('d-block');
          $("#locationLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        }else if (systemParamLink.test(pathArr[1])) {
          $("#settingLink ul").addClass('d-block');
          $("#systemParamLink").addClass('active');
          self.hideContractsAssetsComponentsMenu();
        }else if (consumerExp.test(pathArr[1])) {
          $("#consumerTabLink ul").addClass('d-block');
          $("#consumerTabLink").addClass('active');
          $("#consumerLink").addClass('active');
        }else if (dealerExp.test(pathArr[1])) {
          $("#dealerTabLink ul").addClass('d-block');
          $("#dealerTabLink").addClass('active');
          $("#dealerLink").addClass('active');
        }else if (ratesList.test(pathArr[1])) {
          $("#warrantyTabLink ul").addClass('d-block');
          $("#warrantyTabLink").addClass('active');
          $("#rateLink").addClass('active');
        }else if (srtExp.test(pathArr[1])) {
          $("#warrantyTabLink ul").addClass('d-block');
          $("#warrantyTabLink").addClass('active');
          $("#srtLink").addClass('active');
        }else if (vehicleInformationLink.test(pathArr[1])) {
          $("#warrantyTabLink ul").addClass('d-block');
          $("#warrantyTabLink").addClass('active');
          $("#vehicleInformationLink").addClass('active');
        }else if (publication.test(pathArr[1])) {
          $("#publicationLink").addClass('active');
        }else if (campaign.test(pathArr[1])) {
          $("#campaignTabLink ul").addClass('d-block');
          $("#campaignTabLink").addClass('active');
          $("#campaignLink").addClass('active');
        }else if (campaignRecallStatus.test(pathArr[1])) {
          $("#campaignTabLink ul").addClass('d-block');
          $("#campaignTabLink").addClass('active');
          $("#campaignRecallStatusLink").addClass('active');
        }else if (reportConcern.test(pathArr[1])){
          $("#reportConcernLink").addClass('active');
        }else if (feedbackLog.test(pathArr[1])){
          $("#userFeedbackLink").addClass('active');
        }else if (gallery.test(pathArr[1])){
          $("#galleryLink").addClass('active');
        }else if (technicalSupportRequest.test(pathArr[1])) {
          $("#serviceTabLink ul").addClass('d-block');
          $("#serviceTabLink").addClass('active');
          $("#serviceTechnicalSupportRequest").addClass('active');
        }else if (technicalSupportQueue.test(pathArr[1])) {
          $("#serviceTabLink ul").addClass('d-block');
          $("#serviceTabLink").addClass('active');
          $("#serviceTechnicalSupportQueue").addClass('active');
        }else if (vehicleOption.test(pathArr[1])){
          $("#assetTabLink ul").addClass('d-block');
          $("#assetTabLink").addClass('active');
          $("#vehicleOptionsLink").addClass('active');
        }else if (creditMemoLog.test(pathArr[1])) {
          $("#warrantyTabLink ul").addClass('d-block');
          $("#warrantyTabLink").addClass('active');
          $("#warrantyCreditMemoDataLogLink").addClass('active');
        }else if (positionCode.test(pathArr[1])) {
          $("#warrantyTabLink ul").addClass('d-block');
          $("#warrantyTabLink").addClass('active');
          $("#positionCodeLink").addClass('active');
        }else if (damageCode.test(pathArr[1])){
          $("#warrantyTabLink ul").addClass('d-block');
          $("#warrantyTabLink").addClass('active');
          $("#damageCodeLink").addClass('active');
        }
      }

    }, 1500);

    setTimeout(function () {
      var stickyTop12 = 62;
      $(window).scroll(function () {
        var windowTop = $(window).scrollTop();
        var el = $('.filters-container + .bg-white.data-table');
        if (el.length > 0) {
          if (stickyTop12 < windowTop && !el.is('.sticky') && $(el).outerHeight() > ($(window).height() - 235)) {
            $(".vgt-responsive").css("height", 'auto');
            el.addClass('sticky');
            // when sidebar open and scroll list was overlapping by sidebar so hadled it..
            if ($(".rental-sidebar-right").hasClass('toggled-2')) {

              $(".bg-white.data-table.sticky, .two-section-wrapper.data-table.sticky").css("left", "70px")
            } else {

              $(".bg-white.data-table.sticky, .two-section-wrapper.data-table.sticky").css("left", "265px")
            }
          }
          else if (stickyTop12 > windowTop && el.is('.sticky')) {
            el.removeClass('sticky');
            $(".vgt-responsive").css("height", '45vh');
          }
        }
        else {
          el = $('.two-section-wrapper.data-table');
          if (stickyTop12 < windowTop && !el.is('.sticky') && $(el).outerHeight() > ($(window).height() - 235)) {
            $(".vgt-responsive").css("height", 'auto');
            el.addClass('sticky');
          }
          else if (stickyTop12 > windowTop && el.is('.sticky')) {
            el.removeClass('sticky');
            $(".vgt-responsive").css("height", '45vh');
          }
        }
      });
    }, 5000);

    //moved the toggle menu query to header.vue
    //because the menu stop toggling on page refresh

  },
  methods: {

    //to open submenu and
    initMenu() {

      $('#menu ul').hide();
      $('#menu ul').children('.current').parent().show();
      //$('#menu ul:first').show();
      $('#menu li a').click(
        function () {

          var checkElement = $(this).next();
          if ((checkElement.is('ul')) && (checkElement.is(':visible'))) {
            return false;
          }
          if ((checkElement.is('ul')) && (!checkElement.is(':visible'))) {
            $('#menu ul:visible').slideUp('normal');
            checkElement.slideDown('normal');
            return false;
          }
        }
      );
    },
    //hide drop down menus of Contracts, Assets and Components and add active class to settings link
    hideContractsAssetsComponentsMenu() {
      $("#settingLink").addClass('active');
      $("#settingAssetsLink a").click();
      $("#settingContractLink a").click();
      $("#settingComponentLink a").click();
    },

    checkBuildVersion: function () {
      var self = this;

      var build = localStorage.getItem('build_version');

      $.ajax({
        url: process.env.ROOT_API + "/build/version",
        type: "GET",
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          console.log(data);
          if (data.code == 200 && data.content) {

            self.version = data.content;
            if (build && build != undefined) {


              if (data.content != build) {
                localStorage.setItem('build_version', data.content);

                location.reload(true);
              }

            } else {

              localStorage.setItem('build_version', data.content);
            }
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          console.log(jqXHR);
          if (jqXHR.status == 0) {
            self.errorMsg = "Remote server cannot be reached";
          } else {
            //redirect to login page if user not authenticated
            if (jqXHR.status == 401) {
              //clear previous data
              localStorage.removeItem("user_obj");
              localStorage.removeItem("tkn");
              self.$router.push("/");
            }
            self.error = jqXHR.responseJSON.message;
          }
        }
      });
    },
    checkSidebarToggle() {
      var self = this;

      if (self.userObj !== null || self.userObj !== '') {
        var userJson = JSON.parse(self.userObj);

        self.$parent.loading = true;
        $.ajax({
          url: process.env.ROOT_API + "/user-profile/" + self.loggedinUserId,
          type: "get",
          headers: this.ajxHeaders,
          crossDomain: true,
          data: { flag: "profile" },
          dataType: 'json',
          success: function (data) {
            self.$parent.loading = false;
            if (data.status == "success") {
              userJson.sidebar_toggle = data.content.sidebar_toggle;
              localStorage.setItem('user_obj', JSON.stringify(userJson));
              localStorage.setItem('selectedLang', data.content.default_translate_lang);
              
              EventBus.$emit('sidebar-toggle-event', data.content.sidebar_toggle);
              EventBus.$emit('translate-lang-event', data.content.default_translate_lang);
            }
          },
          error: function (jqXHR, exception) {
            self.$parent.loading = false;
            if (jqXHR.status == 0) {
              self.registerError = "Remote server cannot be reached";
            } else {
              if (jqXHR.status == 401) {
                //clear previous data
                localStorage.removeItem('user_obj');
                localStorage.removeItem('api_token');
                self.$router.push("/login");
              }
            }
          }
        });
      }
    },
    loadMenuLink: function () {

      var currentMenuLoaded = localStorage.getItem("loadMenuLinksFor");

      if (currentMenuLoaded == null || currentMenuLoaded == "reports") {

        EventBus.$emit('loadMenuLink', "modules");
        localStorage.setItem("loadMenuLinksFor", "modules");
        this.sideBarLoadLink = "Reports";

      } else {

        EventBus.$emit('loadMenuLink', "reports");
        localStorage.setItem("loadMenuLinksFor", "reports")
        this.sideBarLoadLink = "Modules";

      }

    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue